import styled from 'styled-components';

export const SIDEBAR_COL_WIDTH = 411;

export const LifeIdSC = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
`;

export const NoConnectionSC = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: white;

  p {
    color: #333d6c;
    opacity: 0.4;
    font-size: 22px;
    margin-top: 16px;
  }
`;

export const MainColSC = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-right: 2px solid #fff;

  .life-id-chat {
    margin-top: 56px;
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;

    .twilio-video {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      z-index: 999;
      transition: width 0.3s, height 0.3s;
      background: black;

      &.draggable {
        cursor: move;
        z-index: 999999;
        width: 360px;
        height: 220px;
        border-radius: 20px;
        overflow: hidden;
        @media only screen and (max-width: 1366px) {
          width: 300px;
          height: 200px;
        }
      }
    }

    &__first-line {
      background-color: #fff;
      border-bottom: 1px #f5f5f7 solid;
      display: flex;
      padding-left: 8px;
      margin-top: -56px;

      > div {
        width: 50%;
      }

      > div:first-child {
        height: 40px;
        margin-top: 8px;
      }
    }
  }
`;

export const VitalColSC = styled.div`
  position: relative;
  width: ${SIDEBAR_COL_WIDTH}px;
  min-width: 411px;
`;
